/**
 * CampaignsEmptyState
 *
 * Centered "There are no campaigns at this moment" copy shown when the active
 * campaigns list is empty. Mirrors Flutter's
 * `lib/presentation/screens/campaigns/widgets/campaigns_empty_list_widget.dart`
 * (centered, secondary-text copy).
 */
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';

export const CampaignsEmptyState = () => {
  const { theme } = useTheme();
  const { l10n } = useLocale();
  const responsive = useResponsiveDesign();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: responsive.spacing.xl,
        textAlign: 'center',
        color: theme.text.secondary,
        fontSize: responsive.font.lg,
      }}
    >
      {l10n.campaigns.noCampaigns}
    </div>
  );
};
